import { Box, Link, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link as RouterLink } from "react-router-dom";
import type { NikolaEvidenceCard as Evidence } from "@chessla/shared";
import { gameReviewUrl } from "../messaging/chat-handoff";

export const NikolaEvidenceCard = ({ evidence, compact }: { evidence: Evidence; compact?: boolean }) => {
  if (compact)
    return evidence.reference ? (
      <Link
        component={RouterLink}
        to={gameReviewUrl(evidence.reference)}
        aria-label={evidence.title}
        sx={{
          my: 0.5,
          px: 1.25,
          display: "flex",
          width: "100%",
          minHeight: 44,
          justifyContent: "space-between",
          alignItems: "center",
          border: "1px solid",
          borderColor: "primary.main",
          color: "primary.main",
          fontSize: ".66rem",
          fontWeight: 950,
          letterSpacing: ".055em",
          textDecoration: "none",
          transition: "background-color 160ms ease, color 160ms ease",
          "&:hover, &:focus-visible": { bgcolor: "primary.main", color: "background.default" },
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        }}
      >
        {evidence.title}
        <OpenInNewIcon aria-hidden sx={{ ml: 1, fontSize: 17 }} />
      </Link>
    ) : null;

  return (
    <Box
      sx={{
        my: 1.5,
        borderBlock: "1px solid",
        borderColor: "rgba(240,236,226,.18)",
        color: "text.primary",
      }}
    >
      <Typography
        sx={{ pt: 1.25, color: "text.secondary", fontSize: ".56rem", fontWeight: 900, letterSpacing: ".12em" }}
      >
        YOUR GAMES
      </Typography>
      <Typography sx={{ mt: 0.55, fontSize: ".69rem", fontWeight: 900, letterSpacing: ".04em" }}>
        {evidence.title}
      </Typography>
      <Typography sx={{ mt: 0.55, fontSize: ".76rem", lineHeight: 1.55 }}>{evidence.summary}</Typography>
      {evidence.reference && (
        <Link
          component={RouterLink}
          to={gameReviewUrl(evidence.reference)}
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: 44,
            mt: 1,
            px: 1.25,
            border: "1px solid",
            borderColor: "primary.main",
            color: "inherit",
            fontSize: ".68rem",
            fontWeight: 950,
            letterSpacing: ".06em",
            textDecoration: "none",
            transition: "background-color 160ms ease, color 160ms ease",
            "&:hover, &:focus-visible": { bgcolor: "primary.main", color: "background.default" },
            "@media (prefers-reduced-motion: reduce)": { transition: "none" },
          }}
        >
          OPEN GAME{evidence.reference.factId || evidence.reference.ply ? " AT THIS MOMENT" : ""}
          <OpenInNewIcon aria-hidden sx={{ ml: 1, fontSize: 18 }} />
        </Link>
      )}
    </Box>
  );
};
